module.exports = __webpack_public_path__ + "media/images/pic/kids-490670073fe8fd6a4593c1abdd7fbe18.svg";